import { successNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const markAsRead = async (id, setLoading, setRefresh) => {
  try {
    const result = await http.put(AUTH_ROUTES.MARK_AS_READ(id));
    console.log(result, "Notification Marked");
    successNotifier()
    // setNotification(result?.data?.notifications?.data?.notifications);
    setLoading(false);
    setRefresh(prev=>!prev);
  } catch (e) {
    setLoading(false);
    console.log(e?.data?.message, "Updating Notification error");
  }
};
